/**
 * AntarDristi — AI Settings drawer access
 *
 * The AiSettings drawer is mounted once at the App level. Anything in the
 * tree that needs to open it calls `useAiSettings().open()` instead of
 * threading a callback through props.
 */

import { createContext, useContext } from 'react';

export const AiSettingsContext = createContext({ open: () => {} });

export function useAiSettings() {
  return useContext(AiSettingsContext);
}
